/*eslint-disable*/
import React, { useEffect, useState } from 'react';
import {
  Card,
  Row,
  Col,
  CardBody,
  Button,
  CardImg,
  CardHeader,
  Table,
  Container,
  Media,
  Modal, ModalHeader, ModalBody,
} from 'reactstrap';
import axios from 'axios';
import MobileHeader1 from 'components/Headers/MobileHeader1';

const ProfileMobile = () => {
  const token = localStorage.token;
  const userid = localStorage.uic;
  const username = localStorage.username;
  const [bergabung, setBergabung] = useState("")
  const [modal6, setModal6] = useState(false);
  const toggless = () => setModal6(!modal6);
  const [name, setName] = useState("");
  const [picture, setPicture] = useState("");
  const [jabatan, setJabatan] = useState("");

  const successCallback = (position) => {
    // console.log(position);
  };

  const errorCallback = (error) => {
    // console.log(error);
  };

  navigator.geolocation.getCurrentPosition(successCallback, errorCallback);

  useEffect(() => {
    getByUser()
    // getPenawaranPo()
  }, [])


  const getByUser = () => {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    axios
      .get(
        `${process.env.REACT_APP_API_BASE_URL}/users/profil/${userid}`,
        { headers }
      )
      .then((data) => {
        setName(data.data.response.name);
        setPicture(data.data.response.karyawan_image);
        setJabatan(data.data.response.jabatan);
        setBergabung(data.data.response.join_date);
      })
      .catch(function (error) {
        console.log(error);
      });
  };


  function cekUsername() {
    axios
      .post(`${process.env.REACT_APP_API_BASE_URL}/users/logout`, { username }, { headers: { Authorization: `Bearer ${token}` } })
      .then(function (res) {
        window.location.href = "/auth/login";
        localStorage.clear();

        // localStorage.removeItem("token");
        // localStorage.removeItem("allinfo");
        // localStorage.removeItem("authority");
        // localStorage.removeItem("email");
        // localStorage.removeItem("name");
        // localStorage.removeItem("token");
        // localStorage.removeItem("usercode");
        // localStorage.removeItem("userId");
        // localStorage.removeItem("username");
        // localStorage.removeItem("usernametoken");
        // localStorage.removeItem("warehouse");
        // localStorage.removeItem("warehouseId");
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  async function handleLogout() {
    cekUsername();
  }

  return (
    <div>
      <MobileHeader1 />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            {/* <Card className="card-profile">
              <CardImg
                alt="..."
                src={require("assets/img/theme/img-1-1000x600.jpg").default}
                top
              />
              <Row className="justify-content-center">
                <Col className="order-lg-2" lg="3">
                  <div className="card-profile-image">
                    <a href="#pablo" onClick={e => e.preventDefault()}>
                      {picture === "" ? (
                        <img
                          alt=""
                          className="rounded-circle"
                          src={"https://i.imgur.com/Hzxpp28.png"}
                        />
                      ) : (
                        <img
                          alt=""
                          className="rounded-circle"
                          src={picture}
                        />
                      )}
                    </a>
                  </div>
                </Col>
              </Row>
              <CardHeader className="text-center border-0 pt-5 pt-md-4 pb-0 pb-md-4">
                <div className="d-flex justify-content-between">
                  <Button
                    hidden
                    className="mr-4"
                    color="info"
                    href="/mobile/profile/new-password"
                    size="sm"
                  >
                    Password
                  </Button>
                  <Button
                    hidden
                    className="float-right"
                    color="danger"
                    onClick={() => handleLogout()}
                    size="sm"
                  >
                    Logout
                  </Button>
                </div>
              </CardHeader>
              <br></br>
              <CardBody className="pt-0">
                <div className="text-center">
                  <h5 className="h3">
                    {name}
                  </h5>
                </div>
                <div className="col">
                  <div className="card-profile-stats d-flex justify-content-center">
                    <div>
                      <span className="description">Bergabung</span><br></br>
                      <span className="description"><b>{bergabung}</b></span>
                    </div>
                    <div>
                      <span className="description">Jabatan</span><br></br>
                      <span className="description"><b>{jabatan}</b></span>
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card> */}
            <Card className="shadow-sm border-0" style={{ borderRadius: "20px", overflow: "hidden" }}>
              <CardImg
                alt="Cover"
                src={require("assets/img/theme/img-1-1000x600.jpg").default}
                top
                style={{ maxHeight: 180, objectFit: "cover" }}
              />
              <div style={{ position: "relative", top: -50, textAlign: "center" }}>
                <div
                  style={{
                    width: 100,
                    height: 100,
                    borderRadius: "50%",
                    border: "4px solid white",
                    overflow: "hidden",
                    margin: "0 auto",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                    backgroundColor: "#fff"
                  }}
                >
                  <img
                    alt="Profile"
                    src={picture === "" ? "https://i.imgur.com/Hzxpp28.png" : picture}
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                </div>
              </div>
              <CardBody className="pt-0 mt-2 text-center">
                <h4 className="mb-1" style={{ fontWeight: 600 }}>{name}</h4>
                {/* <p className="text-muted" style={{ marginBottom: "0.5rem" }}>{jabatan}</p> */}

                <Row className="mt-3 justify-content-center">
                  <Col xs="6" className="text-center">
                    <div style={{ fontSize: 12, color: "#888" }}>Bergabung</div>
                    <div style={{ fontWeight: "bold", fontSize: 14 }}>{bergabung}</div>
                  </Col>
                  <Col xs="6" className="text-center">
                    <div style={{ fontSize: 12, color: "#888" }}>Jabatan</div>
                    <div style={{ fontWeight: "bold", fontSize: 14 }}>{jabatan}</div>
                  </Col>
                </Row>
              </CardBody>
            </Card>

            {/* <Table className="align-items-center bg-white" responsive>

              <tbody>

                <tr>
                  <th scope="row">
                    <Media className="align-items-center">
                      <i className="fa fa-unlock-alt fa-2x" aria-hidden="true"></i>
                      <a
                        className="nav-link"
                        href="/mobile/profile/new-password"
                      >
                        <Media>
                          <span className="mb-0 text-sm">
                            Password
                          </span>
                        </Media>
                      </a>
                    </Media>
                  </th>
                </tr>
                <tr>
                  <th scope="row">
                    <Media className="align-items-center">

                      <i className="fa fa-history fa-2x" aria-hidden="true"></i>
                      <a
                        className="nav-link"
                        href="/mobile/log-akses"
                      >
                        <Media>
                          <span className="mb-0 text-sm">
                            Log Akses
                          </span>
                        </Media>
                      </a>
                    </Media>
                  </th>
                </tr>
                <tr>
                  <th scope="row">
                    <Media className="align-items-center">
                      <i className="fas fa-sign-out-alt fa-2x" />
                      <a
                        className="nav-link"
                        onClick={() => handleLogout()}
                      >
                        <Media>
                          <span className="mb-0 text-sm">
                            Keluar
                          </span>
                        </Media>
                      </a>
                    </Media>
                  </th>
                </tr>
              </tbody>
            </Table> */}
            <Card className="shadow-sm border-0" style={{ borderRadius: 15 }}>
              <CardBody className="p-0">
                {[
                  {
                    icon: "fa-unlock-alt",
                    label: "Ubah Password",
                    link: "/mobile/profile/new-password"
                  },
                  {
                    icon: "fa-history",
                    label: "Log Akses",
                    link: "/mobile/log-akses"
                  },
                  {
                    icon: "fa-sign-out-alt",
                    label: "Keluar",
                    action: handleLogout
                  }
                ].map((item, index) => (
                  <div
                    key={index}
                    onClick={() => {
                      if (item.link) window.location.href = item.link;
                      if (item.action) item.action();
                    }}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "14px 16px",
                      borderBottom: index !== 2 ? "1px solid #eee" : "none",
                      cursor: "pointer",
                    }}
                    className="hover-shadow-sm"
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
                      <i className={`fa ${item.icon} fa-lg`} aria-hidden="true" />
                      <span style={{ fontSize: "15px" }}>{item.label}</span>
                    </div>
                    <i className="fas fa-chevron-right text-muted" />
                  </div>
                ))}
              </CardBody>
            </Card>

            <br></br>
          </div>
        </Row>
      </Container>
      <Modal isOpen={modal6} toggle={toggless}>
        <ModalHeader toggle={toggless} align="center"></ModalHeader>
        <ModalBody align="center">
          <font size="5"><b>Coming Soon</b></font><br /><br />
          <i className="fa fa-cog fa-5x fa-spin" aria-hidden="true"></i><br /><br />
          <Button color="secondary" onClick={toggless}>
            Cancel
          </Button>
        </ModalBody>
      </Modal>
      {/* navigasi bottom */}
      {/* d-md-none d-lg-none d-xl-none */}
      <nav className="navbar bg-white navbar-expand fixed-bottom d-md-none d-lg-none d-xl-none">
        <ul className="navbar-nav nav-justified w-100">
          <li className="nav-item">
            <a href="/mobile/staff-absen" className="nav-link text-center">
              <i className="fas fa-home fa-lg d-block mb-1" />
              <span className="small">Home</span>
            </a>
          </li>
          <li className="nav-item">
            <a href="/mobile/profile" className="nav-link text-center">
              <i className="fas fa-user fa-lg d-block mb-1" />
              <span className="small">Akun</span>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  );
}

export default ProfileMobile;